import { gql } from "@apollo/client";

export const FETCH_LOGOS = gql`
  query FETCH_LOGOS {
    logos {
      id
      name
      thumb: url(size: "300x300")
      url
      originFile
      active
      category
    }
  }
`;

export const UPDATE_LOGO = gql`
  mutation UPDATE_LOGO(
    $id: ID!
    $name: String
    $active: Boolean
    $category: String
    $image: Upload
    $originFile: Upload
  ) {
    updateLogo(
      id: $id
      name: $name
      active: $active
      category: $category
      image: $image
      originFile: $originFile
    ) {
      logo {
        id
        name
        thumb: url(size: "300x300")
        url
        originFile
        active
        category
      }
    }
  }
`;

export const CREATE_LOGO = gql`
  mutation CREATE_LOGO(
    $name: String!
    $image: Upload!
    $originFile: Upload!
    $category: String
  ) {
    createLogo(
      name: $name
      image: $image
      originFile: $originFile
      category: $category
    ) {
      logo {
        id
        name
        thumb: url(size: "300x300")
        url
        originFile
        active
        category
      }
    }
  }
`;
